import { useSuspenseQuery } from "@tanstack/react-query";
import { Button } from "../../../components/ui/button";
import { isomorphicHttpClient } from "../../../httpClient";

const providerIconMap: Record<string, string> = {
  google: "fa-google",
  microsoft: "fa-microsoft",
};

export const LoginProviderLinks = () => {
  const { data } = useSuspenseQuery({
    queryKey: ["login/providers"],
    queryFn: async () => {
      const httpClient = isomorphicHttpClient();

      const { data, error } = await httpClient.GET("/v1/auth/providers");

      if (error) {
        // type do error vem como undefined, deveria vir pelo menos com type genérico
        throw new Error(
          (error as any)?.message ||
            "Erro ao carregar servidores de autorização",
        );
      }

      return data;
    },
  });

  return (
    <>
      {data.map((provider) => (
        <Button key={provider} variant="outline" className="py-6" asChild>
          <a
            className="flex justify-center gap-2"
            href={`${import.meta.env.VITE_PUBLIC_API_URL}/v1/auth/${provider}`}
          >
            <i
              className={`fa-brands ${
                providerIconMap[provider] ?? "fa-user"
              } leading-lg text-lg`}
              aria-hidden
            />
            Entrar com {provider}
          </a>
        </Button>
      ))}
    </>
  );
};
